/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {PossessedGameAssets} from "../PossessedGameAssets";
import {Possessed} from "../Possessed";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {gsap} from 'gsap';
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {autoDetectRenderer, RenderTexture} from "pixi.js";
import * as PIXI from 'pixi.js';
import { NolimitApplication } from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class PossessedBackgroundElements extends PIXI.Container implements StageLayer {

    private mainView:PIXI.Container;

    private backgroundAnimation:PIXI.spine.Spine;
    private tempBackgroundAnimation:PIXI.spine.Spine; // temp spine when switching backgrounds in order to cross fade between spines

    private fsBackgroundFire:PIXI.spine.Spine;

    private bgTransitionLT:gsap.core.Timeline|undefined;

    private blackAndWhiteFilter:PIXI.filters.ColorMatrixFilter;

    constructor() {
        super();
        this.name = "ExorcismBackgroundElements";
        this.init();
    }

    private init() {
        this.mainView = new PIXI.Container();

        this.backgroundAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.BACKGROUND_ANIMATION));
        this.backgroundAnimation.state.setAnimation(0, "candles", true);
        this.backgroundAnimation.position.set(360, 360);

        this.tempBackgroundAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.BACKGROUND_ANIMATION));
        this.tempBackgroundAnimation.position.copyFrom(this.backgroundAnimation.position);
        this.tempBackgroundAnimation.visible = false;

        this.fsBackgroundFire = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.BACKGROUND_FIRE_ANIMATION));
        this.fsBackgroundFire.position.set(360, 360);
        this.fsBackgroundFire.visible = false;

        this.mainView.addChild(this.backgroundAnimation);
        this.mainView.addChild(this.tempBackgroundAnimation);
        this.mainView.addChild(this.fsBackgroundFire);
        this.addChild(this.mainView);

        this.blackAndWhiteFilter = new PIXI.filters.ColorMatrixFilter;
        this.blackAndWhiteFilter.blackAndWhite(true);

        this.onOrientationChanged();
        this.onResize();
    }

    public onOrientationChanged() {

    }

    public onResize() {

    }

    public playShake(numberOfShakes=1):gsap.core.Timeline {
        const tl = gsap.timeline();
        for(let i = 0; i < numberOfShakes; i++) {
            tl.add(gsap.to(this.backgroundAnimation, {duration:0.05, x:356, y:363}));
            tl.add(gsap.to(this.backgroundAnimation, {duration:0.05, x: 360, y:360}));
        }
        return tl;
    }

    public setBlackAndWhiteFilterEnabled(value:boolean) {
        this.mainView.filters = value ? [this.blackAndWhiteFilter] : [];
    }

    public playReverseAnimation():gsap.core.Timeline {
        const reverseAnim = Possessed.xbetEnabled ? "xbetReverse" : "bgReverse"
        return gsap.timeline()
            .add(() => {
                SpineGSAPWrapper.resetSpineState(this.backgroundAnimation);
                //SpineGSAPWrapper.resetSpineState(this.bedGrilAnimation);
                //this.bedGrilAnimation.state.setAnimation(0, "grilReverse", false);
            })
            .add(SpineGSAPWrapper.createTimeline(this.backgroundAnimation, 0, reverseAnim), "<")
            //.add(SpineGSAPWrapper.createTimeline(this.bedGrilAnimation, 0, "grilReverse"), "<")
    }

    // Instantly sets the new background animation
    public setMode(mode:string) {
        SpineGSAPWrapper.resetSpineState(this.backgroundAnimation);
        if (mode == GameMode.FREESPIN || mode == GameMode.FREESPIN_SUPER) {
            this.backgroundAnimation.state.setAnimation(0, "candlesSFS", true);
            this.backgroundAnimation.state.setAnimation(1, "fsBg", true);
            SpineGSAPWrapper.resetSpineState(this.fsBackgroundFire);
            this.fsBackgroundFire.state.setAnimation(0, "frameBurn", true);
            Possessed.foregroundElements?.startFsFire();
        } else if(mode == "XBET") {
            this.backgroundAnimation.state.setAnimation(0, "candles", true);
            this.backgroundAnimation.state.setAnimation(1, "xbetBg", true);
            this.fsBackgroundFire.state.setEmptyAnimation(0, 0);
            this.fsBackgroundFire.visible = false;
            Possessed.foregroundElements?.stopFsFire();
        } else {
            this.backgroundAnimation.state.setAnimation(0, "candles", true);
            this.backgroundAnimation.state.setAnimation(1, "mainBg", true);
            this.fsBackgroundFire.state.setEmptyAnimation(0, 0);
            this.fsBackgroundFire.visible = false;
            Possessed.foregroundElements?.stopFsFire();
        }
    }

    // These switch functions performs a cross fade between the background animations as well as playing a special fire animation on the candles

    public switchToXbet(fadeDur:number) {
        this.bgTransitionLT?.progress(1);
        this.tempBackgroundAnimation.alpha = 0;
        this.bgTransitionLT = gsap.timeline();
        this.bgTransitionLT.add(() => {
            SpineGSAPWrapper.resetSpineState(this.tempBackgroundAnimation);
            this.tempBackgroundAnimation.state.setAnimation(0, "candles", true);
            this.tempBackgroundAnimation.state.setAnimation(1, "xbetBg", true);
        })
        this.bgTransitionLT.add(SpineGSAPWrapper.createTimeline(this.backgroundAnimation, 0, "candlesXbet", 0));
        this.bgTransitionLT.add(gsap.to(this.tempBackgroundAnimation, {alpha: 1, duration: fadeDur}), "<");
        this.bgTransitionLT.add(gsap.to(this.backgroundAnimation, {alpha: 0, duration: fadeDur}), "<");
        this.bgTransitionLT.add(() => {
            this.setMode("XBET");
            this.tempBackgroundAnimation.visible = false;
            this.backgroundAnimation.alpha = 1;
        })
    }
    public switchFromXbet(fadeDur:number) {
        this.bgTransitionLT?.progress(1);
        this.tempBackgroundAnimation.alpha = 0;
        this.bgTransitionLT = gsap.timeline();
        this.bgTransitionLT.add(() => {
            SpineGSAPWrapper.resetSpineState(this.tempBackgroundAnimation);
            this.tempBackgroundAnimation.state.setAnimation(0, "candles", true);
            this.tempBackgroundAnimation.state.setAnimation(1, "mainBg", true);
        })
        this.bgTransitionLT.add(SpineGSAPWrapper.createTimeline(this.backgroundAnimation, 0, "candlesXbet", 0));
        this.bgTransitionLT.add(gsap.to(this.tempBackgroundAnimation, {alpha: 1, duration: fadeDur}), "<");
        this.bgTransitionLT.add(gsap.to(this.backgroundAnimation, {alpha: 0, duration: fadeDur}), "<");
        this.bgTransitionLT.add(() => {
            this.setMode(GameMode.NORMAL);
            this.tempBackgroundAnimation.visible = false;
            this.backgroundAnimation.alpha = 1;
        })
    }

    public onRestore() {
        if(Possessed.model.isFreespins() && !Possessed.model.triggeredFreespins()) {
            this.setMode(GameMode.FREESPIN);
        } else if(Possessed.model.data.enhancedBet) {
            this.setMode("XBET");
        }
    }
}